import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
  public loading: boolean;
  public brandClass: string;

  constructor() { 
    this.loading = false;
    this.brandClass = ""; 
  }

  hide() { this.loading = false; }

  show() { this.loading = true; }

  setColor(brandId: string){
    this.brandClass = "brand" + brandId;
  }
}
